import styled, { css } from "styled-components"
import { MEDIA_QUERIES } from "@constants"

const FieldIsBlurred = css`
  input,
  span {
    color: var(--color--charcoal-900);
  }

  &.is-placeholder {
    input,
    span {
      color: var(--color--charcoal-600);
    }
  }

  .Icon {
    background: var(--color--charcoal-600);
  }
`
const FieldIsFocused = css`
  ${FieldIsBlurred}
  
  input {
    cursor: pointer;
  }

  span {
    border-bottom: 1px dashed var(--color--charcoal-600);
  }

  .Icon {
    background: var(--color--charcoal-600);
  }
`
const FieldIsSubmitted = css`
  ${FieldIsFocused}

  .Icon {
    background: var(--color--green-500);
  }
`

export const JobTitleFieldDIV = styled.div`
  --JobTitleField--height: 24px;
  display: flex;
  align-items: center;
  padding: var(--spacing--XS) 17px;
  width: 100%;
  height: calc(var(--JobTitleField--height) + var(--spacing--XS) * 2);
  background: white;

  .field-wrapper {
    position: relative;
    width: 100%;
    height: var(--JobTitleField--height);

    input,
    span {
      font-weight: 500;
      font-size: 15px;
      height: var(--JobTitleField--height);
      line-height: var(--JobTitleField--height);
      margin-left: 8px;
    }

    input { 
      background: none;
      border: none;
      cursor: pointer;
      left: 0;
      padding-left: 0;
      position: absolute;
      top: 0;
      transition: border 0.15s;
    }

    span {
      color: transparent;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
    }
  }

  /* JobTitleFieldDIV state styles */
  &.is-focused {
    ${FieldIsFocused}
  }

  &.is-blurred {
   ${FieldIsBlurred}
  }

  &.is-submitted {
   ${FieldIsSubmitted}
  }

  ${MEDIA_QUERIES.M} {
    background: transparent;
    padding: var(--spacing--XS) 0;
  }
`;

